import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { getValue } from "../../../../utils/common";
import { EstablishmentTypes, GetActionTitle } from "../Master.constants";

function ActDetails({ action, record : data, onClose }: any) {
    const [act, setAct] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Act Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(data, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'establishment_type',
                label: 'Establishment Type',
                content: getValue(data, 'establishment_type'),
                options: EstablishmentTypes,
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'law',
                label: 'Law',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(data, 'law.name')
            }
        ],
    };

    useEffect(() => {
        if (data) {
            const { establishment_type, law } = data;
            setAct({
                ...act,
                ...data,
                establishment_type: {
                    value: establishment_type,
                    label: establishment_type
                },
                law: law ? { value: law.id, label: law.name } : null
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Act', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={act}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
											<Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ActDetails;
